import { motion } from "framer-motion";
import { Coffee } from "lucide-react";

const ease = [0.2, 0.8, 0.2, 1];

export default function WaitingArea() {
  return (
    <section
      id="waiting"
      data-testid="waiting-section"
      className="relative py-24 md:py-32 bg-[var(--pikko-cream)]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease }}
          className="lg:col-span-7 relative"
        >
          <div
            aria-hidden
            className="absolute -inset-5 rounded-[40px] -z-10"
            style={{
              background:
                "linear-gradient(135deg, rgba(138,107,82,0.12), rgba(217,140,63,0.1))",
            }}
          />
          <div className="rounded-[32px] overflow-hidden shadow-[0_40px_100px_-50px_rgba(46,34,24,0.4)] border border-[rgba(138,107,82,0.15)]">
            <img
              src="/images/waiting.webp"
              alt="Ruang tunggu Pikko Pet Care"
              className="w-full aspect-[4/3] object-cover warm-grade"
              loading="lazy"
            />
          </div>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4, ease }}
            className="absolute -bottom-6 left-6 sm:left-12 glass-light rounded-2xl px-5 py-4 shadow-[0_22px_50px_-25px_rgba(46,34,24,0.35)] flex items-center gap-3"
          >
            <div className="w-10 h-10 rounded-full bg-[var(--pikko-orange)]/15 flex items-center justify-center">
              <Coffee className="w-4.5 h-4.5 text-[var(--pikko-orange-dark)]" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--pikko-brown)] font-semibold">
                Reception
              </div>
              <div className="font-serif text-[16px] text-[var(--pikko-brown-ink)] leading-tight">
                Tenang &amp; nyaman
              </div>
            </div>
          </motion.div>
        </motion.div>

        <div className="lg:col-span-5">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="eyebrow"
          >
            — Welcoming
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, ease }}
            className="mt-4 font-serif text-4xl sm:text-5xl lg:text-[54px] leading-[1.05] tracking-tight text-[var(--pikko-brown-ink)]"
          >
            Comfortable &amp;{" "}
            <span className="italic text-[var(--pikko-orange)]">welcoming</span>{" "}
            environment
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, delay: 0.1, ease }}
            className="mt-6 text-[15px] leading-relaxed text-[var(--pikko-brown-deep)]/85"
          >
            Ruang tunggu yang nyaman dengan suasana klinik yang bersih dan
            modern untuk memberikan pengalaman terbaik bagi owner dan hewan
            kesayangan.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.85, delay: 0.2, ease }}
            className="mt-9 grid grid-cols-3 gap-3"
          >
            {[
              { v: "100%", l: "Bersih" },
              { v: "AC", l: "Climate Control" },
              { v: "09–19", l: "Setiap Hari" },
            ].map((s, i) => (
              <div
                key={i}
                className="rounded-2xl bg-[var(--pikko-cream-warm)] border border-[rgba(138,107,82,0.12)] p-4 text-center"
                data-testid={`waiting-stat-${i}`}
              >
                <div className="font-serif text-[22px] sm:text-[26px] text-[var(--pikko-orange-dark)] leading-tight">
                  {s.v}
                </div>
                <div className="mt-1 text-[10.5px] uppercase tracking-[0.22em] text-[var(--pikko-brown)]/80 font-semibold">
                  {s.l}
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
